import React, { PropsWithChildren } from "react";

import { useCallToActionContext } from "../../callToAction.context";
import { Link } from "../../types/link.types";

type LinkCallToAcitonProps = PropsWithChildren<{
    link: Link;
}>;

const LinkCallToAction = (props: LinkCallToAcitonProps) => {
    const { link, children } = props;

    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <a {...link} {...trackingProperties.click} {...styleProperties.link}>
            {children}
        </a>
    );
};

export { LinkCallToAction };
